import Vue from 'vue';
import About from '~/pages/about.vue';
import RasylvaApi from '~/plugins/rasylva-api';

Vue.use(RasylvaApi);

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('about-wrapper')) {
    new Vue({
      render: (h) => h(About),
    }).$mount('#about-wrapper');
  }
});
